export default __webpack_public_path__ + "static/media/out-for-delivery.00088e79.svg";